import { AuthedAxiosRequests } from 'features/auth/geckoAuthContext'
import useSWR from 'swr'
import { RolodexUserMetadata } from 'types'

// TODO: This should eventually move over into features/rolodex
export const useRolodexPermissionsUserMetadata = (
  axios: AuthedAxiosRequests,
  authorization: string | undefined,
  rolodexURL: string,
  checkAuthorization: boolean = true
) =>
  useSWR<RolodexUserMetadata>(
    ['/api/v2/permissions/user-metadata', authorization],
    async ([url, authorization]) => {
      if (!authorization && checkAuthorization) {
        return Promise.resolve(null)
      }
      const response = await axios.get(`${rolodexURL}${url}`, {
        headers: {
          Accept: 'application/json',
        },
      })
      return response.data
    }
  )
